<div class="page-header">
  <div class="page-title" data-clarity-unmask="true">Logi serwera</div>
  <div class="page-subtitle">api.testy-na-prawko.net</div>
</div>

<div class="log-explorer">
  <!-- Left panel: file browser -->
  <div class="file-panel">
    <div class="file-panel-header">
      <span class="dir-label">Pliki logów</span>
      <p-button
        icon="pi pi-refresh"
        [rounded]="true"
        [text]="true"
        size="small"
        pTooltip="Odśwież listę plików"
        tooltipPosition="right"
        [loading]="loadingFiles"
        (onClick)="loadFilesList()"
        data-clarity-unmask="true"
      />
    </div>

    <div *ngIf="loadingFiles && files.length === 0" class="loading-placeholder">
      <p-progressSpinner strokeWidth="4" [style]="{ width: '32px', height: '32px' }" />
    </div>

    <div *ngIf="!loadingFiles && files.length === 0" class="empty-state">
      Brak plików logów.<br />Kliknij odśwież, aby pobrać listę.
    </div>

    <ul class="file-list" *ngIf="files.length > 0">
      <li class="file-group-header" *ngIf="systemFiles.length > 0">Logi API</li>
      <li
        *ngFor="let file of serverFiles"
        class="file-item"
        [class.selected]="isSelected(file)"
        (click)="selectFile(file)"
      >
        <span class="file-name">{{ file.fileName }}</span>
        <span class="file-meta">
          <span class="file-size">{{ formatSize(file.sizeBytes) }}</span>
          <span class="file-date">{{ formatDate(file.lastModified) }}</span>
        </span>
      </li>
      <li class="file-group-header" *ngIf="systemFiles.length > 0">
        Logi systemowe
      </li>
      <li
        *ngFor="let file of systemFiles"
        class="file-item"
        [class.selected]="isSelected(file)"
        (click)="selectFile(file)"
      >
        <span class="file-name">{{ file.fileName }}</span>
        <span class="file-meta">
          <span class="file-size">{{ formatSize(file.sizeBytes) }}</span>
          <span class="file-date">{{ formatDate(file.lastModified) }}</span>
        </span>
      </li>
    </ul>
  </div>

  <!-- Right panel: log viewer -->
  <div class="viewer-panel">
    <div class="viewer-header" *ngIf="selectedFile">
      <div class="viewer-title">
        <i class="pi pi-file-o"></i>
        <span>{{ selectedFile.fileName }}</span>
        <span class="viewer-meta">
          {{ formatSize(selectedFile.sizeBytes) }} &middot;
          {{ formatDate(selectedFile.lastModified) }}
          <ng-container *ngIf="loadPhase === 'ready'">
            &middot; {{ logLines.length }} linii
          </ng-container>
        </span>
      </div>

      <div class="viewer-nav" *ngIf="loadPhase === 'ready'">
        <span class="nav-group">
          <span class="nav-label nav-label-error">Błędy</span>
          <span class="nav-count">{{ errorCounter() }}</span>
          <button
            type="button"
            class="nav-btn"
            pTooltip="Poprzedni błąd"
            tooltipPosition="bottom"
            [disabled]="errorLineIndexes.length === 0"
            (click)="navigateError(-1)"
            data-clarity-unmask="true"
          >
            <i class="pi pi-chevron-up"></i>
          </button>
          <button
            type="button"
            class="nav-btn"
            pTooltip="Następny błąd"
            tooltipPosition="bottom"
            [disabled]="errorLineIndexes.length === 0"
            (click)="navigateError(1)"
            data-clarity-unmask="true"
          >
            <i class="pi pi-chevron-down"></i>
          </button>
        </span>

        <span class="nav-group">
          <span class="nav-label nav-label-warn">Ostrzeżenia</span>
          <span class="nav-count">{{ warnCounter() }}</span>
          <button
            type="button"
            class="nav-btn"
            pTooltip="Poprzednie ostrzeżenie"
            tooltipPosition="bottom"
            [disabled]="warnLineIndexes.length === 0"
            (click)="navigateWarn(-1)"
            data-clarity-unmask="true"
          >
            <i class="pi pi-chevron-up"></i>
          </button>
          <button
            type="button"
            class="nav-btn"
            pTooltip="Następne ostrzeżenie"
            tooltipPosition="bottom"
            [disabled]="warnLineIndexes.length === 0"
            (click)="navigateWarn(1)"
            data-clarity-unmask="true"
          >
            <i class="pi pi-chevron-down"></i>
          </button>
        </span>
      </div>

      <div class="viewer-actions">
        <p-button
          label="Pobierz"
          icon="pi pi-download"
          size="small"
          (onClick)="downloadFile()"
          [disabled]="!rawContent"
          data-clarity-unmask="true"
        />
        <p-button
          icon="pi pi-refresh"
          [rounded]="true"
          [text]="true"
          size="small"
          pTooltip="Odśwież"
          [loading]="loadPhase === 'downloading' || loadPhase === 'analyzing'"
          (onClick)="refreshContent()"
          data-clarity-unmask="true"
        />
      </div>
    </div>

    <div class="viewer-placeholder" *ngIf="!selectedFile && loadPhase === 'idle'">
      Wybierz plik z listy po lewej stronie.
    </div>

    <div class="viewer-loading" *ngIf="loadPhase === 'downloading'">
      <div class="download-status">
        <div class="download-label">
          Pobieranie pliku... {{ downloadProgress }}%
        </div>
        <p-progressBar
          [value]="downloadProgress"
          [showValue]="false"
          [style]="{ height: '10px', width: '320px' }"
        />
      </div>
    </div>

    <div class="viewer-loading" *ngIf="loadPhase === 'analyzing'">
      <div class="download-status">
        <p-progressSpinner strokeWidth="4" [style]="{ width: '36px', height: '36px' }" />
        <div class="download-label">Analizowanie pliku...</div>
      </div>
    </div>

    <cdk-virtual-scroll-viewport
      *ngIf="loadPhase === 'ready'"
      class="log-window"
      [itemSize]="20"
      [minBufferPx]="600"
      [maxBufferPx]="1200"
    >
      <div
        *cdkVirtualFor="let line of logLines; let i = index; templateCacheSize: 0"
        class="log-line"
        [class.line-highlight]="highlightedLine === i"
        [ngClass]="('level-' + line.level) + (line.lineClass ? ' ' + line.lineClass : '')"
        [title]="line.raw"
      >
        <span class="log-badge" *ngIf="line.level !== 'OTHER'">{{ line.level }}</span>
        <span class="log-text">
          <ng-container *ngFor="let part of line.parts">
            <ng-container *ngIf="part.type === 'text'">{{ part.value }}</ng-container>
            <a
              *ngIf="part.type === 'link'"
              class="log-link"
              [href]="part.href"
              target="_blank"
              rel="noopener noreferrer"
              >{{ part.value }}</a
            >
          </ng-container>
        </span>
      </div>
    </cdk-virtual-scroll-viewport>
  </div>
</div>
